var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 56,
    viewBox: "0 0 161 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 31.0006V24.9728C58 23.1733 58.8998 22.2735 60.6993 22.2735H65.2036L66.1806 23.0353V24.1117H60.749C60.2632 24.1117 60.0203 24.349 60.0203 24.8238V31.1497C60.0203 31.6244 60.2632 31.8618 60.749 31.8618H66.1806V32.9382L65.2036 33.6999H60.6993C58.8998 33.6999 58 32.8002 58 31.0006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5867 31.0834V25.0059H69.5242V31.249C69.5242 31.7569 69.7782 32.0108 70.286 32.0108H73.0184V25.0059H74.9559V33.6999H70.2032C68.4589 33.6999 67.5867 32.8278 67.5867 31.0834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5223 33.0541V32.0108H80.3477C80.8555 32.0108 81.1094 31.7403 81.1094 31.1994C81.1094 30.6363 80.8997 30.3162 80.4801 30.2389L78.6254 29.9408C77.2233 29.6979 76.5223 28.903 76.5223 27.5562C76.5223 25.856 77.3945 25.0059 79.1388 25.0059H81.7718L82.6495 25.6518V26.695H79.2216C78.7027 26.695 78.4433 26.9655 78.4433 27.5065C78.4433 28.0474 78.6641 28.3566 79.1057 28.4338L80.9604 28.7319C82.3514 28.9638 83.0469 29.7642 83.0469 31.1331C83.0469 32.8443 82.1693 33.6999 80.4139 33.6999H77.4L76.5223 33.0541Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5316 31.0834V22.2735H86.4691V25.0059H89.4333V26.695H86.4691V31.249C86.4691 31.7569 86.723 32.0108 87.2308 32.0108H89.5989V33.0541L88.7212 33.6999H87.148C85.4037 33.6999 84.5316 32.8278 84.5316 31.0834Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.706 31.0834V27.6224C90.706 25.8781 91.5782 25.0059 93.3225 25.0059H95.6409C97.3742 25.0059 98.2408 25.8781 98.2408 27.6224V31.0834C98.2408 32.8278 97.3742 33.6999 95.6409 33.6999H93.3225C91.5782 33.6999 90.706 32.8278 90.706 31.0834ZM92.6436 31.249C92.6436 31.7569 92.8975 32.0108 93.4053 32.0108H95.5415C96.0494 32.0108 96.3033 31.7569 96.3033 31.249V27.4568C96.3033 26.949 96.0494 26.695 95.5415 26.695H93.4053C92.8975 26.695 92.6436 26.949 92.6436 27.4568V31.249Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9901 33.6999V25.0059H109.893C111.626 25.0059 112.493 25.8781 112.493 27.6224V33.6999H110.555V27.4568C110.555 26.949 110.302 26.695 109.794 26.695H107.21V33.6999H105.273V26.695H101.928V33.6999H99.9901Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.184 31.0834V27.6224C114.184 25.8781 115.056 25.0059 116.801 25.0059H118.954C120.687 25.0059 121.554 25.8781 121.554 27.6224V30.0733H116.122V31.249C116.122 31.7569 116.376 32.0108 116.884 32.0108H121.222V33.0541L120.345 33.6999H116.801C115.056 33.6999 114.184 32.8278 114.184 31.0834ZM116.122 28.5663H119.616V27.4568C119.616 26.949 119.362 26.695 118.854 26.695H116.884C116.376 26.695 116.122 26.949 116.122 27.4568V28.5663Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.24 33.6999V26.0823C123.638 25.3647 124.4 25.0059 125.526 25.0059H127.265L128.142 25.6518V26.695H125.973C125.598 26.695 125.333 26.7889 125.178 26.9766V33.6999H123.24Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.586 31.0006V24.9728C132.586 23.1733 133.486 22.2735 135.285 22.2735H139.79L140.767 23.0353V24.1117H135.335C134.849 24.1117 134.606 24.349 134.606 24.8238V31.1497C134.606 31.6244 134.849 31.8618 135.335 31.8618H140.767V32.9382L139.79 33.6999H135.285C133.486 33.6999 132.586 32.8002 132.586 31.0006Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.189 23.499V21.5283H144.226V23.499H142.189ZM142.239 33.6999V25.0059H144.177V33.6999H142.239Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.988 31.0834V22.2735H147.925V25.0059H150.889V26.695H147.925V31.249C147.925 31.7569 148.179 32.0108 148.687 32.0108H151.055V33.0541L150.177 33.6999H148.604C146.86 33.6999 145.988 32.8278 145.988 31.0834Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.367 25.304L151.566 25.0059H153.239L155.424 32.0108H155.673L157.859 25.0059H159.531L159.73 25.304L155.938 37.0119H154.265L154.067 36.7138L155.11 33.6999H154.1L151.367 25.304Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1326_104328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 20.8485C25 18.1707 27.1707 16 29.8485 16H44.1515C46.8293 16 49 18.1707 49 20.8485V35.1515C49 37.8293 46.8293 40 44.1515 40H29.8485C27.1707 40 25 37.8293 25 35.1515V20.8485Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9707 31.5002C32.9707 30.8513 33.4968 30.3252 34.1457 30.3252H38.1457C38.7946 30.3252 39.3207 30.8513 39.3207 31.5002C39.3207 32.1491 38.7946 32.6752 38.1457 32.6752H34.1457C33.4968 32.6752 32.9707 32.1491 32.9707 31.5002Z",
    fill: "#1554FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9707 28.0002C32.9707 27.3513 33.4968 26.8252 34.1457 26.8252H41.1457C41.7946 26.8252 42.3207 27.3513 42.3207 28.0002C42.3207 28.6491 41.7946 29.1752 41.1457 29.1752H34.1457C33.4968 29.1752 32.9707 28.6491 32.9707 28.0002Z",
    fill: "#1554FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9707 24.5002C32.9707 23.8513 33.4968 23.3252 34.1457 23.3252H44.1457C44.7946 23.3252 45.3207 23.8513 45.3207 24.5002C45.3207 25.1491 44.7946 25.6752 44.1457 25.6752H34.1457C33.4968 25.6752 32.9707 25.1491 32.9707 24.5002Z",
    fill: "#1554FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 32.7407V23.2505C28.75 20.5776 30.078 19.2412 32.7339 19.2412H39.7881L41.0822 20.2562V21.5757H32.7592C31.795 21.5757 31.3129 22.0494 31.3129 22.9967V32.9945C31.3129 33.9418 31.795 34.4155 32.7592 34.4155H41.0822V35.735L39.7881 36.75H32.7339C30.078 36.75 28.75 35.4135 28.75 32.7407Z",
    fill: "#1554FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1326_104328",
    x: 0.250006,
    y: -0.499996,
    width: 73.5,
    height: 73.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.186389 0 0 0 0 0.312642 0 0 0 0 0.508333 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1326_104328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1326_104328",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/navLogo.868152fdf8098866ea1ab2439f07adbd.svg";
export { ForwardRef as ReactComponent };